import Vue from 'vue'

export default function (pluginsHandler) {
    return {
        name: 'sortable',
        treeMixins: {
            props: {
                sortableMakeItemFolder: {
                    type: Boolean,
                    default: false
                },
                sortableOnlyOneRoot: {
                    type: Boolean,
                    default: false
                }
            },
            data() {
                return {
                    sortableDraggedComponent: null,
                    sortableDraggedItem: null,
                    sortableDraggedItemIndex: null,
                    sortableTargetItem: null,
                    sortableIndexItem: null,
                    sortableOldData: null,
                    sortableIsDataChanged: false,
                }
            },
            methods:{
                sortableSave() {
                    this.eventBus.$emit('sortable:save', this.data)
                    Vue.set(this, 'sortableOldData', JSON.stringify(this.dataProcessed))
                    this.sortableIsDataChanged = false
                },
                sortableCancel(){
                    this.eventBus.$emit('sortable:cancel')
                    //create new object from old data - every time when reset data
                    Vue.set(this, 'dataProcessed',  JSON.parse(this.sortableOldData))
                    this.sortableIsDataChanged = false
                }
            },
            mounted() {
                this.sortableOldData = JSON.stringify(this.dataProcessed)

                this.eventBus.$on('sortable:drag-start', (component, ev) => {
                    let draggedItemId = null
                    let container = null

                    this.sortableDraggedComponent = component

                    //TODO: place mouse to top left corner

                    //TODO: change mouse type
                    if (!!component.$parent.data) {
                        container = this.dataProcessed
                        draggedItemId = container.indexOf(component.rowItem)
                    } else {
                        container = component.$parent.rowItem.children
                        draggedItemId = container.indexOf(component.rowItem)
                    }

                    if (draggedItemId > -1) {
                        //store dragged item data
                        this.sortableDraggedItem = Object.assign({}, container.splice(draggedItemId, 1).pop())
                        this.sortableDraggedItemIndex = draggedItemId
                        //TODO: replace dragged item with fake item
                    }
                    this.sortableTargetItem = component.$parent
                    this.eventBus.$emit('sortable:start', this.sortableDraggedItem)
                })

                //presentate position of where to drop item
                this.eventBus.$on('sortable:drag-over', (component, ev) => {

                    if (this.sortableDraggedComponent &&
                        !!!this.sortableDraggedComponent.$parent.data &&
                         this.sortableOnlyOneRoot &&
                         component.$parent.$options._componentTag === 'oc-tree-internal'
                        ){
                        return;
                    }

                    //check where to place dragged element before or after
                    let elPosition = window.getComputedStyle(component.$el)
                    let elHeight = parseInt(elPosition.height, 10)
                    let elWidth = parseInt(elPosition.width, 10)

                    let mousePos = ev.clientY - ev.target.getBoundingClientRect().top
                    let mousePosX = ev.clientX - ev.target.getBoundingClientRect().left

                    let indexOfItem = null

                    if (!!this.sortableTargetItem.$parent.rowItem) {
                        indexOfItem = this.sortableTargetItem.$parent.rowItem.children.indexOf(component.rowItem)
                    } else {
                        indexOfItem = this.dataProcessed.indexOf(component.rowItem)
                    }

                    //todo change margins for dropping
                    if (!component.isFolder && this.sortableMakeItemFolder &&
                        elWidth / 2 < mousePosX && elWidth > mousePosX) {
                        indexOfItem = null
                        component.$el.style = 'border: 2px solid #7C3155'
                    } else if (mousePos > 0 && mousePos <= (elHeight / 2) && indexOfItem === 0) {
                        component.$el.style = 'border-top: 2px solid #7C3155'
                    } else if (mousePos >= (elHeight / 2)) {
                        indexOfItem += 1
                        component.$el.style = 'border-bottom: 2px solid #7C3155'
                    }

                    this.sortableIndexItem = indexOfItem
                })

                this.eventBus.$on('sortable:drag-leave', (component) => {
                    component.$el.style = 'border: none'
                })

                this.eventBus.$on('sortable:drag-enter', (component, ev) => {
                    if (this.sortableOnlyOneRoot){
                        if (component.$parent.$options._componentTag === 'oc-tree-internal'){
                            this.sortableTargetItem = this.sortableDraggedComponent
                            return;
                        }
                    }
                    this.sortableTargetItem = component
                })
                this.eventBus.$on('sortable:drag-end', (component) => {
                    let container = !!this.sortableTargetItem.$parent.data ?
                        this.dataProcessed : this.sortableTargetItem.$parent.rowItem.children
                    if (this.sortableIndexItem !== null) {
                        container.splice(this.sortableIndexItem, 0, Object.assign({}, this.sortableDraggedItem))
                    } else {
                        // set item to its default position if attempt to place it in wrong place
                        if (this.sortableTargetItem.$vnode.componentOptions.tag === 'oc-tree-internal') {
                            this.sortableTargetItem.dataProcessed.splice(this.sortableDraggedItemIndex,0,this.sortableDraggedItem)
                            return
                        }

                        //check if target items has container for children if not set it
                        if (!!!this.sortableTargetItem.rowItem.children) {
                            Vue.set(this.sortableTargetItem.rowItem, 'children', [])
                        }

                        if (this.dataProcessed.length === 0){
                            this.dataProcessed.push(this.sortableDraggedItem)
                        }else {
                            this.sortableTargetItem.rowItem.children.push(this.sortableDraggedItem)
                        }
                    }

                    this.sortableIsDataChanged = JSON.stringify(this.data) !== this.sortableOldData

                    this.sortableIndexItem = null

                    let id = 0

                    function reoderInternalIds(source) {
                        Object.keys(source).forEach((key) => {
                            Vue.set(source[key].internal, '_id', ++id)
                            if (!!source[key].children) {
                                reoderInternalIds(source[key].children)
                            }
                        })
                    }
                    reoderInternalIds(this.data)

                    this.eventBus.$emit('sortable:end', this.sortableTargetItem)
                })
            }
        },
        rowEvents: (treeItem) => {
            return {
                dragstart(event) {
                    event.stopPropagation()
                    treeItem.treeObject.eventBus.$emit('sortable:drag-start', treeItem, event)
                },
                dragover(event) {
                    event.stopPropagation()
                    treeItem.treeObject.eventBus.$emit('sortable:drag-over', treeItem, event)
                },
                dragenter(event) {
                    event.stopPropagation()
                    treeItem.treeObject.eventBus.$emit('sortable:drag-enter', treeItem, event)
                },
                dragleave(event) {
                    event.stopPropagation()
                    treeItem.treeObject.eventBus.$emit('sortable:drag-leave', treeItem, event)
                },
                dragend(event) {
                    event.stopPropagation()
                    treeItem.treeObject.eventBus.$emit('sortable:drag-end', treeItem, event)
                }
            }
        },
        rowAttrs: (treeItem) => {
            return {
                draggable: true
            }

        },
        slotsContent: {
            'beforeTree' : `<oc-button-input v-show="sortableIsDataChanged" class="btn btn-sm btn-danger oc-tree-sortable-button-cancel" @click="sortableCancel">Cancel Order</oc-button-input>
            <oc-button-input v-show="sortableIsDataChanged" class="btn btn-sm btn-success oc-tree-sortable-button-save" @click="sortableSave">Save Order</oc-button-input>`,
        },
    }
}
